module.exports = __webpack_public_path__ + "static/img/prize01.fd5b4914.gif";